import { EntityInput, isURLAbsolute, LinkProps } from "helpers/url";

/* todo: refactor this */
export function groupHref(
  entity: EntityInput,
  region?,
  origin?
): LinkProps["href"] {
  /* origin used only for /g_something/analogi/ link */
  if (origin) {
    return groupAs(entity, region, origin);
  }

  let obj: LinkProps["href"] = {
    pathname: "/group/[category]",
    query: {
      category: entity?.category || "",
    },
  };

  if (entity.url) {
    const alias = [...entity.url.matchAll(/\/g_(.[^\\/]+)/g)][0]?.[1];
    if (alias && !entity.url.includes("analogi")) {
      obj.query = { category: alias };
    } else {
      obj = {
        pathname: entity.url,
      };
    }
  }

  if (region) {
    obj.query = {
      ...((obj.query as object) || {}),
      region,
    };
  }
  return obj;
}

/* todo: refactor this */
export function groupAs(
  entity: EntityInput,
  region = "",
  origin = ""
): LinkProps["as"] {
  /* this used only for /g_something/analogi/ link */
  const category = entity?.category || "";
  const currentRegion = region ? `r_${region}/` : "";

  /* this used only for /g_something/analogi/ link */
  if (isURLAbsolute(category)) {
    return category;
  }

  if (entity.url) {
    return entity.url;
  }

  const isAnalogi = Boolean(category.match("/analogi"));
  const path = `${origin}/g_${category}${category.endsWith("/") ? "" : "/"}`;

  if (!isAnalogi && currentRegion) {
    return path + currentRegion;
  }

  return path;
}
